import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import HeaderSection from "../components/shared/HeaderSection";

const Services = () => {
  const services = [
    {
      title: "Internet Services",
      description: [
        "Domain Name Search, Transfer & DNS Services",
        "Web Hosting: Shared Hosting, WordPress Hosting, VPS Hosting",
        "Business Email Services, Email Migrations & Anti-Spam Protection",
      ],
      image: "/images/services/internet-services.jpg",
      link: "/services/internet-services",
    },
    {
      title: "Software Solutions",
      description: [
        "Custom Software Development (Desktop & Web Applications)",
        "API Development & Middleware Integrations",
        "Web Design: Tailored CMS Solutions with a Focus on User-Centric Design",
      ],
      image: "/images/services/software-solutions.jpg",
      link: "/services/software-solutions",
    },
    {
      title: "Mobile App Development",
      description: [
        "Native Android & iOS App Development",
        "Cross-Platform Solutions (React Native, Flutter)",
        "UI/UX Design & Prototyping",
        "App Store Deployment & Maintenance",
      ],
      image: "/images/services/mobile-app-development.jpg",
      link: "/services/mobile-app-development",
    },
    {
      title: "Web Application Development",
      description: [
        "Custom Web Applications",
        "Modern Web Technologies",
        "Back-End Stability",
        "Responsive Website Development",
      ],
      image: "/images/services/web-app-development.jpg",
      link: "/services/web-app-development",
    },
    {
      title: "ERP Consultation & Support",
      description: [
        "ERP Implementation & Customization",
        "ERP System Upgrades & Integration",
        "Ongoing ERP Support & Maintenance",
      ],
      image: "/images/services/erp-consultation.jpg",
      link: "/services/erp-consultation",
    },
    {
      title: "CCTV & Surveillance Solutions",
      description: [
        "CCTV Camera Installation & Configuration",
        "Remote Monitoring Systems",
        "Maintenance & Upgrades",
        "Integrated Security Solutions",
      ],
      image: "/images/services/cctv-solutions.jpg",
      link: "/services/cctv-&-surveillance-solutions",
    },
    {
      title: "Hardware Solutions",
      description: [
        "Hardware Installation, Maintenance & Upgrades",
        "Hardware Recycling & Data Destruction (100% Secure Erasure)",
      ],
      image: "/images/services/hardware-solutions.jpg",
      link: "/services/hardware-solutions",
    },
    {
      title: "Security Solutions",
      description: [
        "Software & Hardware-Based Security Solutions",
        "Data Protection & Erasure Services",
        "Security Audits & Compliance Solutions",
      ],
      image: "/images/services/security-solutions.jpg",
      link: "/services/security-solutions",
    },
  ];

  return (
    <>
      {/* Services Section */}
      <section className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-100 text-gray-800">
        {/* Header Section */}
        <HeaderSection
          image="/images/bg-images/services-bg.jpeg"
          header="Services"
          subHeader="Empowering Businesses with Tailored IT Solutions"
        />

        {/* Main Content */}
        <div className="py-16 px-6">
          <div className="container mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-40 object-cover rounded-lg mb-4"
                />
                <h2 className="text-2xl font-bold mb-4 text-blue-600">
                  {service.title}
                </h2>
                <ul className="space-y-2">
                  {service.description.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-center space-x-2 text-gray-600"
                    >
                      <FaCheckCircle
                        size={18}
                        className="flex-shrink-0 text-blue-600"
                      />
                      <span className="leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
                {service.link && (
                  <Link
                    to={service.link}
                    className="inline-block mt-4 text-blue-600 hover:underline"
                  >
                    Learn More
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    
    </>
  );
};

export default Services;